import { DetailFieldList } from "@/shared/components";
import styles from "./detail-item-cards.module.scss";
import type { DetailItemCardsProps } from "./types-detail-item-cards";

/** Um cartão por item da seção (Motores, Guincho Guindaste), com os campos em duas colunas. */
export function DetailItemCardsView({ testId, cards }: DetailItemCardsProps) {
  return (
    <div className={styles.cards} data-testid={testId}>
      {cards.map(({ testId: cardTestId, title, titleTestId, fieldsTestId, fields }) => (
        <article key={cardTestId} className={styles.card} data-testid={cardTestId}>
          {title ? (
            <h3 className={styles.title} data-testid={titleTestId}>
              {title}
            </h3>
          ) : null}
          <DetailFieldList testId={fieldsTestId} fields={fields} />
        </article>
      ))}
    </div>
  );
}
